import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "basic-list-header-info" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", null, _toDisplayString(_ctx.title), 1),
    _createVNode("p", null, _toDisplayString(_ctx.value), 1),
    (!!_ctx.bordered)
      ? (_openBlock(), _createBlock("em", _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}